(function () {
  if (window.MairazStitchingFeedback) return;
  window.MairazStitchingFeedback = true;

  var ROOT_SELECTOR = '[data-mrz-stitching-controls]';
  var SIZE_SELECTOR = '[data-mrz-shared-sizes] input[name="properties[Size]"]';

  /* NOTE, 20 Sep 2026: an accelerated checkout guard briefly lived here, for a
     trial of Shopify's dynamic checkout buttons on the product page. It was
     removed with the buttons because those buttons skip the cart, and the cart
     is where the mandatory Terms of Service checkbox lives. If dynamic checkout
     is ever revisited, it also needs a guard for the Express Shipping fee,
     which assets/mairaz-express-fee.js adds as a separate cart line and which
     an accelerated checkout would skip. */

  /* REMOVED 20 Sep 2026: the free-text height check.

     This file used to hold a HEIGHT_TESTS array of regular expressions and a
     statesHeight() helper. A custom order is unusable without a height, and at
     the time the only place a height could be given was the free-text
     measurements box, so every submission was scanned for one and blocked if
     no pattern matched.

     That blocked real customers. The patterns only accepted "Height <digit>",
     a feet mark such as 5' or "5 ft", and 120-199 cm, so perfectly clear
     answers failed: "5.4 feet", "1.64 m", "five foot four", "Ht 5 4". The
     customer saw a message asking for a height they believed they had already
     given, with nothing on screen to correct, and could not add to cart.

     Custom Stitched now renders its own Height select, the same control
     Standard Stitched uses (snippets/mairaz-stitching-controls.liquid). A
     select cannot be mistyped, so there is nothing left to parse and no reason
     to guess at free text. Do not reintroduce a text scan here: if a new
     mandatory value is needed, give it a real field. */

  function formFor(root) {
    var id = root.getAttribute('data-form-id');
    return id ? document.getElementById(id) : null;
  }

  function selectedRadio(root, field) {
    return root.querySelector('input[name="' + field.name + '"]:checked:not([disabled])');
  }

  function missingFields(root) {
    var fields = root.querySelectorAll('[required]:not([disabled])');
    var missing = [];
    var seenRadioNames = {};

    for (var i = 0; i < fields.length; i += 1) {
      var field = fields[i];
      if (field.type === 'radio') {
        if (!seenRadioNames[field.name] && !selectedRadio(root, field)) missing.push(field);
        seenRadioNames[field.name] = true;
      } else if (!String(field.value || '').trim()) {
        missing.push(field);
      }
    }

    return missing;
  }

  function clearFeedback(root) {
    root.querySelectorAll('[data-mrz-size-pills]').forEach(function (group) {
      group.removeAttribute('data-invalid');
    });
    root.querySelectorAll('[aria-invalid="true"]').forEach(function (field) {
      field.removeAttribute('aria-invalid');
    });
  }

  function has(fields, token) {
    return fields.some(function (field) {
      return String(field.name || '').indexOf(token) > -1;
    });
  }

  function promptFor(fields) {
    var hasSize = has(fields, '[Size]');
    var hasHeight = has(fields, '[Height]');
    var hasMeasurements = has(fields, '[Measurements]');

    if (hasMeasurements && hasHeight) return 'Please select your height and add your measurements.';
    if (hasMeasurements) return 'Please add your measurements.';
    if (hasSize && hasHeight) return 'Please select your size and height.';
    if (hasHeight) return 'Please select your height.';
    if (hasSize) return 'Please select your size.';
    return 'Please complete the highlighted fields.';
  }

  function showMissing(root) {
    var missing = missingFields(root);
    var message = root.querySelector('[data-mrz-stitching-message]');
    clearFeedback(root);

    if (!missing.length) {
      if (message) {
        message.textContent = '';
        message.hidden = true;
      }
      delete root.dataset.mrzValidationAttempted;
      return null;
    }

    root.dataset.mrzValidationAttempted = 'true';
    missing.forEach(function (field) {
      if (field.type === 'radio') {
        var pillGroup = field.closest('[data-mrz-size-pills]');
        if (pillGroup) pillGroup.setAttribute('data-invalid', 'true');
      } else {
        field.setAttribute('aria-invalid', 'true');
      }
    });

    if (message) {
      message.textContent = promptFor(missing);
      message.hidden = false;
    }
    return missing[0];
  }

  function pickerFor(root) {
    var scope = root.closest('product-info') || root.closest('.product') || document;
    return scope.querySelector('variant-selects');
  }

  function currentType(root) {
    var picker = pickerFor(root);
    if (!picker) return '';
    var radio = picker.querySelector('input[type="radio"]:checked');
    if (radio) return String(radio.value || '').toLowerCase();
    var select = picker.querySelector('select');
    return select ? String(select.value || '').toLowerCase() : '';
  }

  function typeControl(root, needle) {
    var picker = pickerFor(root);
    if (!picker) return null;
    var radios = Array.prototype.slice.call(picker.querySelectorAll('input[type="radio"]'));
    for (var i = 0; i < radios.length; i += 1) {
      if (String(radios[i].value || '').toLowerCase().indexOf(needle) > -1) return radios[i];
    }
    return null;
  }

  function sharedSizes(root) {
    return Array.prototype.slice.call(root.querySelectorAll(SIZE_SELECTOR));
  }

  function applyTypeState(root) {
    var type = currentType(root);
    var isStandard = type.indexOf('standard') > -1;
    var isCustom = type.indexOf('custom') > -1;

    sharedSizes(root).forEach(function (input) {
      if (isStandard) {
        input.setAttribute('required', 'required');
        input.setAttribute('aria-required', 'true');
      } else {
        input.removeAttribute('required');
        input.removeAttribute('aria-required');
        input.checked = false;
      }
    });

    if (!isStandard) {
      var group = root.querySelector('[data-mrz-shared-sizes]');
      if (group) group.removeAttribute('data-invalid');
    }

    var lining = root.querySelector('[data-mrz-lining]');
    if (lining) {
      var stitched = isStandard || isCustom;
      lining.hidden = !stitched;
      lining.querySelectorAll('input').forEach(function (input) { input.disabled = !stitched; });
    }
  }

  function chooseStandardFor(root, value) {
    var standard = typeControl(root, 'standard');
    if (!standard || standard.checked) return;

    standard.click();

    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;
      var matched = null;
      sharedSizes(root).forEach(function (input) {
        input.setAttribute('required', 'required');
        input.setAttribute('aria-required', 'true');
        if (input.value === value) matched = input;
      });
      if (matched && !matched.checked) matched.checked = true;
      if (attempts >= 8) {
        window.clearInterval(timer);
        sync(root);
      }
    }, 150);
  }

  function sync(root) {
    var form = formFor(root);
    if (form) form.noValidate = true;

    if (root.dataset.mrzValidationAttempted === 'true') showMissing(root);
    else clearFeedback(root);
  }

  function focusField(field) {
    if (!field) return;
    try { field.focus({ preventScroll: false }); }
    catch (error) { field.focus(); }
  }

  function validateSubmission(root, event) {
    var missing = missingFields(root);
    if (!missing.length) return false;
    event.preventDefault();
    event.stopImmediatePropagation();
    focusField(showMissing(root));
    return true;
  }

  function rootsForForm(form) {
    return Array.prototype.slice.call(document.querySelectorAll(ROOT_SELECTOR)).filter(function (root) {
      return formFor(root) === form;
    });
  }

  function syncAll(scope) {
    (scope || document).querySelectorAll(ROOT_SELECTOR).forEach(function (root) {
      applyTypeState(root);
      sync(root);
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest ? event.target.closest('[name="add"]') : null;
    var form = button && button.closest ? button.closest('form') : null;
    if (!button || !form || button.disabled) return;

    var roots = rootsForForm(form);
    for (var i = 0; i < roots.length; i += 1) {
      if (validateSubmission(roots[i], event)) return;
    }
  }, true);

  window.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || form.tagName !== 'FORM') return;

    var roots = rootsForForm(form);
    for (var i = 0; i < roots.length; i += 1) {
      if (validateSubmission(roots[i], event)) return;
    }
  }, true);

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    if (target.closest('[data-mrz-shared-sizes]') && target.checked && target.name === 'properties[Size]') {
      var sizeRoot = target.closest(ROOT_SELECTOR);
      if (sizeRoot) chooseStandardFor(sizeRoot, target.value);
    }

    var root = target.closest(ROOT_SELECTOR);
    if (root) sync(root);

    if (target.closest('variant-selects')) {
      document.querySelectorAll(ROOT_SELECTOR).forEach(applyTypeState);
      window.setTimeout(function () { syncAll(document); }, 350);
    }
  });

  document.addEventListener('input', function (event) {
    var root = event.target && event.target.closest ? event.target.closest(ROOT_SELECTOR) : null;
    if (root) sync(root);
  });

  function boot() {
    syncAll(document);
    window.setTimeout(function () { syncAll(document); }, 500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();

  document.addEventListener('shopify:section:load', function (event) {
    syncAll(event.target || document);
  });
})();